"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NavTabsContext = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _Tab = _interopRequireDefault(require("./Tab"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var NavTabsContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.NavTabsContext = NavTabsContext;

var getPropInChild = function getPropInChild(child, propName) {
  return child.props ? child.props[propName] ? child.props[propName] : child.props.children ? getPropInChild(child.props.children, propName) : undefined : undefined;
};

var getLabelFromTab = function getLabelFromTab(child) {
  if (typeof child === "string") {
    return child.toString();
  } else if (child.props.children) {
    return Array.isArray(child.props.children) ? getLabelFromTab(child.props.children[0]) : getLabelFromTab(child.props.children);
  }
};

var getPreviousTabIndex = function getPreviousTabIndex(array, initialIndex) {
  var index = initialIndex === 0 ? array.length - 1 : initialIndex - 1;

  while (getPropInChild(array[index], "disabled")) {
    index = index === 0 ? array.length - 1 : index - 1;
  }

  return index;
};

var getNextTabIndex = function getNextTabIndex(array, initialIndex) {
  var index = initialIndex === array.length - 1 ? 0 : initialIndex + 1;

  while (getPropInChild(array[index], "disabled")) {
    index = index === array.length - 1 ? 0 : index + 1;
  }

  return index;
};

var DxcNavTabs = function DxcNavTabs(_ref) {
  var _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? "top" : _ref$iconPosition,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      children = _ref.children;
  var colorsTheme = (0, _useTheme["default"])();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      innerFocus = _useState2[0],
      setInnerFocus = _useState2[1];

  var contextValue = (0, _react.useMemo)(function () {
    return {
      iconPosition: iconPosition,
      tabIndex: tabIndex,
      hasIcons: _react["default"].Children.toArray(children).some(function (child) {
        return getPropInChild(child, "icon");
      }),
      focusedLabel: innerFocus === null ? undefined : getLabelFromTab(children[innerFocus])
    };
  }, [iconPosition, tabIndex, innerFocus]);

  var handleOnKeyDown = function handleOnKeyDown(event) {
    var activeTab = _react["default"].Children.toArray(children).findIndex(function (child) {
      return getPropInChild(child, "active");
    });

    switch (event.key) {
      case "Left":
      case "ArrowLeft":
        event.preventDefault();
        setInnerFocus(getPreviousTabIndex(children, innerFocus === null ? activeTab : innerFocus));
        break;

      case "Right":
      case "ArrowRight":
        event.preventDefault();
        setInnerFocus(getNextTabIndex(children, innerFocus === null ? activeTab : innerFocus));
        break;
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.tabs
  }, /*#__PURE__*/_react["default"].createElement(NavTabsContainer, {
    onKeyDown: handleOnKeyDown,
    role: "tablist",
    "aria-label": "Navigation tabs"
  }, /*#__PURE__*/_react["default"].createElement(NavTabsContext.Provider, {
    value: contextValue
  }, children)));
};

DxcNavTabs.Tab = _Tab["default"];

var NavTabsContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n"])));

var _default = DxcNavTabs;
exports["default"] = _default;